"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const face_1 = require("./face");
exports.pop = (face, scaleBy, colour, popSize = 1.0) => {
    let active;
    let inactive;
    let baseFace;
    if (scaleBy > 1.01) {
        const flippedBase = face_1.scale(face_1.flip(face), scaleBy);
        flippedBase.colour = colour; // do update colour as 'new' as part of new thing
        inactive = [flippedBase];
        baseFace = face_1.scale(face, scaleBy);
    }
    else if (scaleBy < 0.99) {
        inactive = [face_1.cloneFace(face)];
        baseFace = face_1.scale(face, scaleBy);
    }
    else {
        //fuck it ... assume scale is actually so don't do extra things
        inactive = [];
        baseFace = face;
    }
    const baseFaceSize = face_1.faceSize(face);
    // TODO also apply pop size for other pops
    const transform = face.normal
        .clone()
        .multiplyScalar(scaleBy * baseFaceSize * popSize);
    // 'Top' of pop... just move scaled face in direction of normal:
    active = [face_1.translateFace(baseFace, transform, colour)];
    for (let b = 0; b < baseFace.vertices.length; b++) {
        let [i, j] = b < baseFace.vertices.length - 1 ? [b, b + 1] : [b, 0];
        // probably okay to re-use the vertices as shouldn't be modified anyway
        let vertices = [
            baseFace.vertices[i],
            baseFace.vertices[j],
            baseFace.vertices[j].clone().add(transform),
            baseFace.vertices[i].clone().add(transform)
        ];
        let normal = vertices[1]
            .clone()
            .sub(vertices[0])
            .cross(vertices[3].clone().sub(vertices[0]))
            .normalize();
        active.push({
            vertices,
            normal,
            colour
        });
    }
    return {
        active,
        inactive
    };
};
exports.pyramid = (face, scaleBy, colour) => {
    let active;
    let inactive;
    let baseFace;
    if (scaleBy > 1.01) {
        const flippedBase = face_1.scale(face_1.flip(face), scaleBy);
        flippedBase.colour = colour; // do update colour as 'new' as part of new thing
        inactive = [flippedBase];
        baseFace = face_1.scale(face, scaleBy);
    }
    else if (scaleBy < 0.99) {
        inactive = [face_1.cloneFace(face)];
        baseFace = face_1.scale(face, scaleBy);
    }
    else {
        //fuck it ... assume scale is actually so don't do extra things
        inactive = [];
        baseFace = face;
    }
    const baseFaceSize = face_1.faceSize(face);
    // TODO also apply pop size for other pops
    const top = face_1.centre(face.vertices).add(face.normal.clone().multiplyScalar(face_1.faceSize(baseFace)));
    active = [];
    for (let b = 0; b < baseFace.vertices.length; b++) {
        let [i, j] = b < baseFace.vertices.length - 1 ? [b, b + 1] : [b, 0];
        // probably okay to re-use the vertices as shouldn't be modified anyway
        let vertices = [baseFace.vertices[i], baseFace.vertices[j], top];
        let normal = vertices[1]
            .clone()
            .sub(vertices[0])
            .cross(vertices[2].clone().sub(vertices[0]))
            .normalize();
        active.push({
            vertices,
            normal,
            colour
        });
    }
    return {
        active,
        inactive
    };
};
exports.truncatedPyramid = (face, scaleBy, colour) => {
    let active;
    let inactive;
    let baseFace;
    if (scaleBy > 1.01) {
        const flippedBase = face_1.scale(face_1.flip(face), scaleBy);
        flippedBase.colour = colour; // do update colour as 'new' as part of new thing
        inactive = [flippedBase];
        baseFace = face_1.scale(face, scaleBy);
    }
    else if (scaleBy < 0.99) {
        inactive = [face_1.cloneFace(face)];
        baseFace = face_1.scale(face, scaleBy);
    }
    else {
        //fuck it ... assume scale is actually so don't do extra things
        inactive = [];
        baseFace = face;
    }
    const baseFaceSize = face_1.faceSize(face);
    const transform = face.normal.clone().multiplyScalar(scaleBy * baseFaceSize);
    const fullTopFace = face_1.translateFace(baseFace, transform, colour);
    const topFace = face_1.scale(fullTopFace, 0.5);
    active = [topFace];
    for (let b = 0; b < baseFace.vertices.length; b++) {
        let [i, j] = b < baseFace.vertices.length - 1 ? [b, b + 1] : [b, 0];
        // probably okay to re-use the vertices as shouldn't be modified anyway
        let vertices = [
            baseFace.vertices[i],
            baseFace.vertices[j],
            topFace.vertices[j],
            topFace.vertices[i]
        ];
        let normal = vertices[1]
            .clone()
            .sub(vertices[0])
            .cross(vertices[3].clone().sub(vertices[0]))
            .normalize();
        active.push({
            vertices,
            normal,
            colour
        });
    }
    return {
        active,
        inactive
    };
};
exports.bevel = (face, scaleBy, colour) => {
    let active;
    let inactive = [];
    const transform = face.normal
        .clone()
        .multiplyScalar(-0.1 * scaleBy * face_1.faceSize(face));
    const fullTopFace = face_1.translateFace(face, transform, colour);
    const topFace = face_1.scale(fullTopFace, 0.5);
    active = [topFace];
    for (let b = 0; b < face.vertices.length; b++) {
        let [i, j] = b < face.vertices.length - 1 ? [b, b + 1] : [b, 0];
        let vertices = [
            face.vertices[i],
            face.vertices[j],
            topFace.vertices[j],
            topFace.vertices[i]
        ];
        let normal = vertices[1]
            .clone()
            .sub(vertices[0])
            .cross(vertices[3].clone().sub(vertices[0]))
            .normalize();
        // actually the main change here(!)
        inactive.push({
            vertices,
            normal,
            colour
        });
    }
    return {
        active,
        inactive
    };
};
exports.jump = (face, scaleBy, colour) => {
    let active;
    let inactive = [face];
    const transform = face.normal
        .clone()
        .multiplyScalar(2.0 * face_1.faceSize(face) * scaleBy);
    const halfTransform = transform.clone().multiplyScalar(0.5);
    const scaledFace = face_1.translateFace(face_1.scale(face, scaleBy), halfTransform, colour);
    const flipped = face_1.flip(scaledFace);
    const topPlane = face_1.translateFace(scaledFace, halfTransform, colour);
    active = [topPlane];
    for (let b = 0; b < scaledFace.vertices.length; b++) {
        let [i, j] = b < scaledFace.vertices.length - 1 ? [b, b + 1] : [b, 0];
        // probably okay to re-use the vertices as shouldn't be modified anyway
        let vertices = [
            scaledFace.vertices[i],
            scaledFace.vertices[j],
            topPlane.vertices[j],
            topPlane.vertices[i]
        ];
        let normal = vertices[1]
            .clone()
            .sub(vertices[0])
            .cross(vertices[3].clone().sub(vertices[0]))
            .normalize();
        active.push({
            vertices,
            normal,
            colour
        });
    }
    active.push(flipped); // so bottom is last
    return {
        active,
        inactive
    };
};
exports.twist = (face, scaleBy, colour, twistBy) => {
    // 2 inactive faces, original, flipped and twisted with new colour; 1 active: twisted with new colour
    // face.normal.clone() important as stuff gets fucked otherwise
    const scaledTwisted = face_1.translateFace(face_1.scale(face_1.rotate(face_1.cloneFace(face), face_1.centre(face.vertices), face.normal.clone(), twistBy), scaleBy), face.normal.clone().multiplyScalar(0.005), colour);
    const flipped = face_1.flip(scaledTwisted);
    const inactive = [face_1.cloneFace(face), flipped];
    const active = [scaledTwisted];
    console.log({ active, inactive });
    return {
        active,
        inactive
    };
};



// WEBPACK FOOTER //
// ./src/components/three/ruleApplications.ts